/** Copy of the spInvoices page (Operations), ported from VentaHub. */
export const spInvoices = {
  title: 'SP invoices',
  description: 'Invoices from service providers: freight, handling and the like.',
  empty: 'No SP invoices to show',
  emptyHint: 'Nothing matches these filters.',
  filters: {
    warehouse: 'Warehouse',
    party: 'Service provider',
    text: 'Invoice number',
    dates: 'Invoice date',
    void: 'Include voided',
    kind: 'Type',
  },
  columns: {
    number: 'Invoice number',
    date: 'Invoice date',
    warehouse: 'Warehouse',
    party: 'Service provider',
    type: 'Type',
    amountWoTax: 'Excl. tax',
    amount: 'Amount',
    paid: 'Paid',
    cndnValue: 'Credit/debit notes',
    creditPeriod: 'Credit days',
    orderDetail: 'Order',
    viId: 'Vendor invoice',
    invoiceId: 'Sales invoice',
    comment: 'Comment',
    valid: 'Status',
    actions: 'Actions',
  },
  actions: {
    record: 'Record an SP invoice',
    edit: 'Edit',
    editOne: 'Edit SP invoice {{code}}',
    delete: 'Delete',
    deleteOne: 'Delete SP invoice {{code}}',
  },
  form: {
    hint: 'A bill from a service provider. Link it to the vendor or sales invoice it is a cost of, if there is one.',
    editTitle: 'Edit SP invoice {{code}}',
    chooseProvider: 'Choose a service provider',
    chooseType: 'Choose a type',
    currency: 'Currency',
    amount: 'Amount incl. tax',
    vendorInvoice: 'Vendor invoice number',
    salesInvoice: 'Sales invoice number',
    chooseWarehouse: 'Choose a warehouse.',
    needProvider: 'Choose a service provider.',
    needType: 'Choose a type.',
    needNumber: 'Fill in the invoice number.',
    needAmount: 'Fill in the amount.',
    badCurrency: 'Type a 3-letter currency code.',
    badAmount: 'Amounts are numbers of zero or more, with up to 4 decimals.',
    badCredit: 'Credit days must be a whole number.',
    recordButton: 'Record',
    recorded: 'SP invoice {{code}} recorded.',
    edited: 'SP invoice {{code}} saved.',
  },
  delete: {
    title: 'Delete SP invoice {{code}}?',
    description: 'Only an SP invoice with no payments against it can be deleted.',
    done: 'SP invoice {{code}} deleted.',
  },
} as const
